exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HighlightExercise-module__wrapper___3wPyy{display:grid;justify-items:center;gap:1rem;z-index:1}.HighlightExercise-module__wrapper___3wPyy .HighlightExercise-module__sentence___3gHeM{padding:1rem;background-color:#fff;border-radius:15px}.HighlightExercise-module__wrapper___3wPyy p,.HighlightExercise-module__wrapper___3wPyy span{-webkit-user-select:none;-moz-user-select:none;user-select:none}", ""]);

// exports
exports.locals = {
	"wrapper": "HighlightExercise-module__wrapper___3wPyy",
	"sentence": "HighlightExercise-module__sentence___3gHeM"
};